import { getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  heading: 'Offer headline will come here',
  subHeading: 'Offer subtext come here',
  ctaText: 'T&C',
  ctaPressMetaData: {
    id: 'ctaText'
  },
  isCardPressable: false,
  cardPressMetaData: {
    id: 'cardMetaData'
  },
  numberOfLinesSubHeading: 1,
  imageUrl: 'https://assets.airtel.in/static-assets/recast/hotstar.svg'
}, getTestId('OfferCardWidgetContainer'));